export const PREVIEW_SUBTITLE =
  "Here are resources and content that connect directly to your curriculum and instructional goals";
